import { ContentfulImage } from '@components/contentful-image'
import { Markdown } from '@components/markdown'
import type { BentoPieceRectangleThreePartsPartFragment } from '@graphql/queries/GetBentoOne.graphql'
import type { FunctionComponent } from 'react'

import styles from './bento-rectangle-three-parts.module.scss'

export const Part: FunctionComponent<Props> = ({ heading, copy, image }) => {
    return (
        <div className={styles.section}>
            <div className={styles.heading}>
                <Markdown tag='p' typeStyle='heading-md' markdown={heading} />
            </div>
            <div className={styles.copy}>
                <Markdown tag='p' typeStyle='body-md' markdown={copy} />
            </div>
            <div className={styles.image}>
                {image && (
                    <ContentfulImage
                        className={styles.image}
                        url={image.url}
                        width={image.width}
                        height={image.height}
                        contentType={image.contentType}
                        sizes='(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 400px'
                        alt={image.alt}
                    />
                )}
            </div>
        </div>
    )
}

export default Part

type Props = Omit<BentoPieceRectangleThreePartsPartFragment, 'sys' | 'type'> & {
    copy?: string
}
